import React, { useState } from 'react';
import './Footer.css';
import logoFooter from '../Assets/logo.png';
import whatsapp from '../Assets/whatsaap_icon.png';
import facebook from '../Assets/fb_icon.png';
import instagram from '../Assets/ig_icon.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [activeLink, setActiveLink] = useState(null);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribed with email:', email);
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  const handleLinkClick = (linkName) => {
    setActiveLink(linkName);
    window.scrollTo(0, 0);
  };

  const socialLinks = {
    whatsapp: 'https://wa.me/254728986068',
    facebook: 'https://facebook.com/',
    instagram: 'https://instagram.com/'
  };

  const footerLinks = [
    { name: 'Company', path: '/' },
    { name: 'Products', path: '/' },
    { name: 'Offices', path: '/' },
    { name: 'About', path: '/' },
    { name: 'Contact', path: '/' }
  ];

  return (
    <footer className='footer'>
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <Link to="/">
              <img src={logoFooter} alt="Etolee Livestock Link Logo" />
            </Link>
            <p className="footer-description">
              Connecting farmers with quality livestock since 2025.
            </p>
          </div>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            {footerLinks.map((link) => (
              <li key={link.name}>
                <Link 
                  to={link.path} 
                  className={activeLink === link.name ? 'active' : ''}
                  onClick={() => handleLinkClick(link.name)}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Newsletter</h3>
          <form onSubmit={handleSubscribe} className="newsletter-form">
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={subscribed}>
              {subscribed ? 'Thank You!' : 'Subscribe'}
            </button>
          </form>
          {subscribed && (
            <p className="subscription-message">
              Thank you for subscribing to our newsletter!
            </p>
          )}
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Follow Us</h3>
          <div className="socials">
            <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer">
              <img src={whatsapp} alt="WhatsApp" />
            </a>
            <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
              <img src={instagram} alt="Instagram" />
            </a>
            <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
              <img src={facebook} alt="Facebook" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <hr className="footer-divider" />
        <div className="copyright">
          <p>© {new Date().getFullYear()} Etolee Livestock Link. All rights reserved.</p>
          <div className="legal-links">
            <Link to="/">Privacy Policy</Link>
            <span> | </span>
            <Link to="/">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;